export default __webpack_public_path__ + "static/media/close.45a137c7.svg";